<template>
	<div class="users">
		<v-layout row wrap>
			<v-flex md10>
				<filter-list class="mb-3"
					v-bind:value="filterValue"
					v-on:selected-filter="selectedFilter"
				/>
			</v-flex>
			<v-flex md2 class="text-xs-right">
				<button-create :text="'Usuario'" v-bind:href="href"></button-create>
			</v-flex>
		</v-layout>
		<table-run v-bind:columns="columns"
				   v-bind:rows="rows"
				   v-bind:selectable="false"
				   v-bind:include-delete="false"
				   v-bind:include-export-to-excel="false"
				   v-bind:include-options="true"
				   v-bind:include-switch="true"
				   v-bind:include-settings="true"
				   v-on:go-to-edit-page="editUser"
				   v-bind:include-delete-single="true"
				   v-on:on-delete-event="deleteRow"
				   v-on:on-sortable-event="columnSortableEvent"
				   v-on:on-search-event="searchEmployee"
				   v-on:on-change-state="updateState"
				   class="no-selectable-table">
			<template slot="rows" scope="props">
				<td>{{props.row.name}}</td>
				<td>{{props.row.lastname}}</td>
				<td>{{props.row.email}}</td>
				<td>{{props.row.sucursal_name}}</td>
				<td v-if="props.row.flag_supervisor > 0">Supervisor</td>
				<td v-else>Mucama</td>
			</template>
		</table-run>
		<div class="text-xs-right mt-3">
			<v-pagination
				v-bind:length="numberPage"
				:total-visible="pagesVisible"
				v-model="page"
				v-on:input="loadData(page)"
				></v-pagination>
  		</div>
	</div>
</template>

<script>

import TableRun from 'table-run';
import ButtonCreate from '@/components/shared/ButtonCreate';
import FilterList from '@/components/shared/FilterList';
import mixin from '@/shared/mixins';

function created() {
	this.loadData(1);
}

async function loadData(page) {
	const url = page === 1 ? 'housemaid' : `housemaid?page=${page}`;
	const params = {
		filter_groups: this.filterGroup,
		sort: this.sort,
	};
	const userData = await this.$http.get(url, { params });
	this.rows = userData.data.data;
	this.numberPage = userData.data.last_page;
}

function columnSortableEvent({ id }) {
	const newColumn = this.columns.filter(column => column.id === id);
	newColumn[0].isSortable = newColumn[0].isSortable.down ?
		{ down: false, up: true } : { down: true, up: false };
	const columnName = newColumn[0].code;
	let direction = '';
	if (newColumn[0].isSortable.up) {
		direction = 'ASC';
	} else {
		direction = 'DESC';
	}
	const sort = {
		key: columnName,
		direction,
	};
	this.sort[0] = sort;
	this.loadData(1);
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	let flag = 0;
	if (filter.id === 1) {
		this.filterGroup[0].filters[0] = {};
		this.loadData(1);
	} else {
		flag = filter.id === 2 ? 1 : 0;
		const params = {
			key: 'flagactive',
			value: flag,
			operator: 'eq',
		};
		this.filterGroup[0].filters[0] = params;
		this.loadData(this.page);
	}
}

function editUser(row) {
	this.$router.push({ name: 'users-config', params: { userId: row.id } });
}

async function deleteRow({ id }) {
	const url = `housemaid/${id}`;
	await this.$http.delete(url, id);
	this.loadData(this.page);
}

function pagesVisible() {
	return this.numberPage < 5 ? this.numberPage : 5;
}

function searchEmployee(search) {
	this.search = search;
	if (search) {
		const params = {
			key: 'name',
			value: search,
			operator: 'ct',
		};
		const paramsLastName = {
			key: 'lastname',
			value: search,
			operator: 'ct',
		};
		const paramsEmail = {
			key: 'email',
			value: search,
			operator: 'ct',
		};
		const paramsFlagActive = {
			key: 'flagactive',
			value: this.filterValue === 2 ? 1 : 0,
			operator: 'eq',
		};
		this.filterGroup = [
			{
				or: true,
				filters: [params, paramsEmail, paramsLastName],
			},
		];

		if (this.filterValue !== 1) {
			this.filterGroup[0].filters.push(paramsFlagActive);
		}
		this.loadData(this.page);
	} else {
		this.filterGroup[0].filters[1] = {};
		this.filterGroup[0].filters[1] = {};
		this.filterGroup[0].filters[1] = {};
		this.loadData(1);
	}
}

async function updateState({ id }) {
	const newRow = this.rows.filter(row => row.id === id);
	await this.$http.put(`housemaid/${id}`, { flagactive: newRow[0].flagactive });
}

export default {
	created,
	name: 'users-list',
	components: {
		ButtonCreate,
		FilterList,
		TableRun,
	},
	computed: {
		pagesVisible,
	},
	data() {
		return {
			href: { name: 'users-new' },
			columns: [
				{ id: 1, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Apellidos', code: 'lastname', isSortable: { down: true, up: false } },
				{ id: 3, name: 'Mail', code: 'email', isSortable: { down: true, up: false } },
				{ id: 4, name: 'Sucursal', code: 'sucursal_name', isSortable: { down: true, up: false } },
				{ id: 5, name: 'Cargo', code: 'flag_supervisor', isSortable: { down: true, up: false } },
			],
			rows: [],
			filterValue: 1,
			page: 1,
			numberPage: 1,
			charge: '',
			search: '',
			filterGroup: [
				{
					filters: [],
				},
			],
			sort: [],
		};
	},
	methods: {
		columnSortableEvent,
		selectedFilter,
		loadData,
		editUser,
		deleteRow,
		searchEmployee,
		updateState,
	},
	mixins: mixin,
};
</script>



// WEBPACK FOOTER //
// List.vue?2da78ae1